define('casino/game-mode',['jquery', 'casino/casino', 'casino/info', 'casino/casino-data'], function($, casino, casinoInfo, casinoData) {
	'use strict';

	var gameMode = {};

	gameMode.getGameMode = getGameMode;
	gameMode.updateGameModeButtons = updateGameModeButtons;

	gameMode.MODE_ONE_GAME = 1;
	gameMode.MODE_TWO_GAMES = 2;
	gameMode.MODE_FOUR_GAMES = 4;

	var loadedGames = [];

	var NETENT = 3;

	var ACTIVE = 'active';

    function getSplitHash(hash, index) {
        return hash.split(';')[index];
    }

    function getGameIdsFromHash(hash) {
        var gameIdPart = getSplitHash(hash, 0).toLowerCase();
        if (gameIdPart.slice(2, 7) === 'game=' || gameIdPart.slice(2, 8) === 'group=') {
            var gameIds = gameIdPart.slice(2).split(',');
            return gameIds;
        }
        return [];
    }

	/**
	 * @returns {number} 1, 2 or 4
	 * @throws {Error} if no mode is selected
	 */
	function getGameMode() {
		var $ingame = $('#casino-ingame');
		var $gameMode = $ingame.find('#game-mode');
		var $modeButton = $gameMode.find('.toggle:not(.game-mode-layout) a.active span');

        var gameIds = getGameIdsFromHash(location.hash);

		if ($modeButton.hasClass('s24-view1') || gameIds.length === 1) {
			return gameMode.MODE_ONE_GAME;
		}

		if ($modeButton.hasClass('s24-view2')) {
			return gameMode.MODE_TWO_GAMES;
		}

		if ($modeButton.hasClass('s24-view4')) {
			return gameMode.MODE_FOUR_GAMES;
		}

		console.trace();
		throw new Error('No game mode is active!');
	}

	function updateGameModeButtons(gameIds) {
		var $gameMode = $('#casino-ingame').find('#game-mode');

		if (casinoInfo.isSmallScreen() || !doWeHaveFourNetentGames() || !allGamesAreNetEnt(gameIds)) {
			$gameMode.hide().next().hide();
			return;
		} else {
            $gameMode.show().next().show();
        }

		var numberOfGames = gameIds.length;
		var selectClass = '.s24-view' + numberOfGames;

		var $gameModeButtons = $gameMode.find('.toggle:not(.game-mode-layout) a');
		setActiveModeButton($gameModeButtons, selectClass);
		setGameLinksOnModeButtons($gameModeButtons, gameIds);
	}


    function allGamesAreNetEnt(gameIds) {
        for(var i = 0; i < gameIds.length; i++) {
            var game = casino.getMatchingGame(gameIds[i]);
            if (game.provider !== NETENT) {
				return false;
			}
        }
        return true;
    }

	function doWeHaveFourNetentGames() {
		var netEntGameCounter = 0;
		$.each(casinoData.games, function(id, game) {
			return !(game.provider === NETENT && ++netEntGameCounter >= gameMode.MODE_FOUR_GAMES);
		});
		return netEntGameCounter >= gameMode.MODE_FOUR_GAMES;
	}

	function setActiveModeButton($gameModeButtons, selectClass) {
		$gameModeButtons.removeClass(ACTIVE);
		$gameModeButtons.find(selectClass).parent().addClass(ACTIVE);
	}

	function setGameLinksOnModeButtons($gameModeButtons, gameIds) {
		loadedGames = [];

		for(var i = 0; i < gameIds.length; i++) {
			loadedGames[i] = gameIds[i];
		}

		while (loadedGames.length < 4) {
			loadedGames.push(casino.getRandomNetentGameId(loadedGames));
		}

		var modeLink = '#!';
		modeLink += loadedGames[0];
		$gameModeButtons.eq(0).attr('href', modeLink);
		modeLink += ',' + loadedGames[1];
		$gameModeButtons.eq(1).attr('href', modeLink);
		modeLink += ',' + loadedGames[2];
		modeLink += ',' + loadedGames[3];
		$gameModeButtons.eq(2).attr('href', modeLink);
	}

	return gameMode;
});

